import {BitmapCountUp} from "@nolimitcity/slot-game/bin/component/BitmapCountUp";
import {TimelineLite} from "gsap";
import {WalkOfShameGameAssets} from "../../../WalkOfShameGameAssets";
import {Layers, WalkOfShameLayers} from "../../../view/WalkOfShameLayers";
import {WalkOfShame} from "../../../WalkOfShame";

export class BigWinCountUp extends PIXI.Container {
    private readonly _countUp: BitmapCountUp;
    private _endingScale: number = 0.6;

    constructor() {
        super();

        const style = {
            fontName: WalkOfShameGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: 52,
            tint: parseInt(("#ffffff").replace(/^#/, ''), 16)
        };
        this._countUp = new BitmapCountUp(style);
        this._countUp.shrinkSize = true;
        this._countUp.visible = false;
        this.addChild(this._countUp);
        this.position.set(360, 480);
        WalkOfShameLayers.getLayer(Layers.WIN_COUNT_UP)?.addChild(this);
    }

    public getCountUpAnimation(from: number, to: number, duration: number): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        tl.add([
            () => {
                this._countUp.maxTextWidth = 580;
                this._countUp.scale.set(1);
                this._countUp.alpha = 1;
                this._countUp.visible = true;
            },
            this._countUp.getCountUpAnimation(from, to, duration, `power3.out`)
        ]);

        return tl;
    }

    public stay(): TimelineLite {
        const tl: TimelineLite = new TimelineLite();

        tl.to(this._countUp.scale, {
            duration: 0.5,
            x: this._endingScale,
            y: this._endingScale,
            ease: `elastic.out(1, 1)`
        });

        return tl;
    }

    public remove(): void {
        const tl: TimelineLite = new TimelineLite();
        if (this._countUp.visible) {
            tl.add(() => {
                WalkOfShame.winWays.hideInitialWinWays();
            }, 0);
            tl.to(this._countUp, {duration: 0.3, alpha: 0, y: 40, ease: `power2.easeIn`}, 0);

            tl.add(() => {
                this._countUp.visible = false;
                this._countUp.y = 0;
            });
        }
    }
}